import { render } from "./ProcessComponent.vue?vue&type=template&id=7b89e069"
import script from "./ProcessComponent.vue?vue&type=script&lang=js"
export * from "./ProcessComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__